import { t } from "@/services/i18n";

const sportStatusIconActive = {
  code: "check-e",
  color: "var(--nxgds-text-semantic-success-primary, #15a772)",
} as const;

const sportStatusIconInactive = {
  code: "void",
  color: "var(--nxgds-text-semantic-error-primary, #dd415c)",
} as const;

const sportStatusIconGameStatus = {
  code: "globe-a2",
  color: "var(--nxgds-text-semantic-info-primary, #0088ef)",
} as const;

export const sportStatusOptions = [
  {
    value: 1,
    title: "common.status.active",
    icon: sportStatusIconActive,
  },
  {
    value: 2,
    title: "common.status.inactive",
    icon: sportStatusIconInactive,
  },
  {
    value: 3,
    title: "common.status.game_status",
    icon: sportStatusIconGameStatus,
  },
];

export const sportGamesStatusOptions = [
  {
    value: 1,
    title: "common.status.active",
    icon: sportStatusIconActive,
  },
  {
    value: 2,
    title: "common.status.inactive",
    icon: sportStatusIconInactive,
  },
];

export const sportDefaultEventSelectionOptions = [
  { value: 1, title: "Selected" },
  { value: 2, title: "Not Selected" },
];

export const sportUsViewEventRowLayoutOptions = [
  { value: -1, title: "general.none" },
  { value: "6pack", title: "sport_metadata.us_view_event_row_layout.6pack" },
  { value: "horizontal", title: "sport_metadata.us_view_event_row_layout.horizontal" },
  { value: "vertical", title: "sport_metadata.us_view_event_row_layout.vertical" },
];

export const SPORT_MAX_POSITION = 999999;
export const US_VIEW_EVENT_ROW_LAYOUT_ID = "us_view_event_row_layout";

export function sportMaxPositionError(max = SPORT_MAX_POSITION): string {
  return String(t("metadata.notifications.max_position")).replace(/\{\{\s*max\s*\}\}/g, String(max));
}

export function sportPositionValidator(value: unknown) {
  if (value == null || value === "") return undefined;
  if (Number(value) > SPORT_MAX_POSITION) {
    return sportMaxPositionError();
  }
  return undefined;
}
